import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import Login from './components/Login';
import Onboarding from './components/Onboarding';
import VerifyOtp from './components/VerifyOtp'
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primeicons/primeicons.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Navigate to="/signup" />} />
      <Route path="/signup" element={<Login />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/verify-email" element={<VerifyOtp />} />
    </Routes>
  </BrowserRouter>
);